import { AutocheckoutFormComponent } from "./../../shared/autocheckout-form/autocheckout-form.component";
import { Component, OnInit } from "@angular/core";
import { RetailCartService } from "src/app/services/retail/retail-cart.service";
import {
  StoreMetaInfo,
  RetailCartItem,
  RetailCart,
} from "src/app/models/cart-models";
import { SafeHtmlPipe } from "src/app/pipes/safe-html.pipe";
import { LoaderService } from "src/app/services/loader/loader.service";
import {
  ModalController,
  AlertController,
  NavController,
} from "@ionic/angular";
import { Router } from "@angular/router";
import { BottomModalComponent } from "src/app/modals/bottom-modal/bottom-modal.component";
import { I18ConfigService } from "src/app/services/shared/I18-config.service";
import { ActivatedRoute } from "@angular/router";
import { SeoService } from "src/app/services/seo.service";
import { TranslateService } from "@ngx-translate/core";
import { title } from "process";
import { CheckoutFormComponent } from "../../shared/checkout-form/checkout-form.component";
import { AutoCheckoutService } from "src/app/services/auto-checkout/auto-checkout.service";

@Component({
  selector: "app-retail-cart",
  templateUrl: "./retail-cart.page.html",
  styleUrls: ["./retail-cart.page.scss"],
})
export class RetailCartPage implements OnInit {
  cartItems: RetailCartItem[];
  locationId: number;
  storeId: number;
  storeInfo: StoreMetaInfo;
  discountConfig: any;
  productDiscountConfig: any;
  cartDiscountConfig: any;
  cart: RetailCart;
  totalQuantity: number;
  totalPrice: number;
  finaltotalPrice: number;
  discountAmount: number;
  productDiscountAmount: number;
  cartDiscountAmount: number;
  productDiscountText: string;
  cartDiscountText: string;
  discount: number;
  storeCharges: number;
  currencyCode: string;
  showLoader: number;
  clearTitle: string;
  clearText: string;
  noBtn: string;
  yesBtn: string;
  isValidToCheckout: boolean;
  finalPriceError: string;
  checkPriceMessage: string;
  additionalDiscountText: string;
  isAsp: boolean;
  image = "../../../../assets/images/no_data.svg";

  // tslint:disable-next-line: max-line-length
  constructor(
    private seoService: SeoService,
    private activatedRoute: ActivatedRoute,
    private retailCartService: RetailCartService,
    private safeHtml: SafeHtmlPipe,
    private loaderService: LoaderService,
    private modalController: ModalController,
    private alertController: AlertController,
    private navControl: NavController,
    private i18ConfigService: I18ConfigService,
    private autoCheckoutService: AutoCheckoutService,
    private translate: TranslateService
  ) {
    this.initCartState();
    this.currencyCode = i18ConfigService.getCurrency();
    this.seoService.updatePageTitle("cart|retail");
  }

  initCartState() {
    this.storeInfo = {} as StoreMetaInfo;
    this.discountConfig = {};
    this.productDiscountConfig = {};
    this.cartDiscountConfig = {};
    this.cartItems = [] as RetailCartItem[];
    this.cart = {} as RetailCart;
    this.storeCharges = 0;
    this.discount = 0;
    this.discountAmount = 0;
    this.productDiscountAmount = 0;
    this.cartDiscountAmount = 0;
    this.showLoader = 1;
    this.isValidToCheckout = true;
    this.finalPriceError = "";
    this.checkPriceMessage = "";
    this.additionalDiscountText = "";
    this.isAsp = false;
    if (localStorage.getItem("pid") == "asp") {
      this.isValidToCheckout = false;
      this.isAsp = true;
    }
  }

  ngOnInit() {}

  ionViewWillEnter() {
    this.locationId = this.activatedRoute.snapshot.params["loc"];
    this.storeId = this.activatedRoute.snapshot.params["storeId"];
    this.initCartState();
    this.renderCartData();
  }

  updateSalesSummary(){
    this.cartDiscountAmount = this.discountConfig.cartDiscountAmount;
    this.cartDiscountText = this.discountConfig.cartDiscountText;
    this.productDiscountAmount = this.discountConfig.productDiscountAmount;
    this.productDiscountText = this.discountConfig.productDiscountText;
    this.discountAmount = this.discountConfig.totalDiscount;
  }

  updateCartParams() {
    this.totalQuantity = 0;
    this.totalPrice = 0;
    this.finaltotalPrice = 0;
    this.discountAmount = 0;
    this.productDiscountAmount = 0;
    this.cartDiscountAmount = 0;
    this.cartItems.forEach((element, index) => {
      this.totalQuantity += element.quantity;
      let itemTotalPrice = 0;
      let nonDiscountableProducts = 0;
      let multipleOfOfferApplicable = 0;
      itemTotalPrice = element.finalPrice * element.quantity; // -0 is added to convert string value (assigned to interger variable) to number
      this.totalPrice += itemTotalPrice;
      this.finaltotalPrice = this.totalPrice;
      this.cartItems[index].totalPrice = itemTotalPrice;
    });

    this.updateSalesSummary();

    if (this.cartItems.length <= 0) {
      this.showLoader = 0;
    }
    if (this.isAsp) {
      this.isValidToCheckout = false;
      this.discount = 0;
    }
  }
  renderCartData() {
    this.retailCartService.getCartList().subscribe((response) => {
      this.storeInfo = response.storeMetaInfo || ({} as StoreMetaInfo);
      this.cartItems = response.productList || ([] as RetailCartItem[]);
      this.storeId = this.storeInfo.id;
      this.discountConfig = response.discountConfig || {};
      this.updateCartParams();
      this.cart.storeId = this.storeInfo.id;
      this.cart.locationId = response.location_id;
      this.locationId = response.location_id;
      this.cart.list = [...this.cartItems];
    });
  }

  async checkFinalPrice() {
    let postData = {};
    postData["products"] = [];
    this.finalPriceError = "";
    this.cartItems.forEach((element, index) => {
      let product_data = {
        url: element.productUrl,
        quantity: element.quantity,
        title: element.title,
      };
      postData["products"].push(product_data);
    });
    postData["storeLocationId"] = this.locationId;
    await this.loaderService.presentLoading("Checking...");
    this.retailCartService
      .getFinalPrice(postData)
      .subscribe(async (response) => {
        if (response.status == 0) {
          this.finalPriceError = response.errorMessage;
        }
        if (response.status == 1) {
          this.finaltotalPrice = parseInt(response.finalPrice);
          localStorage.setItem("finalPrice", response.finalPrice);
          localStorage.setItem("discount", response.discount);
          this.discount = parseInt(response.discount);
          this.isValidToCheckout = true;
        }
        await this.loaderService.loading.dismiss();
        this.checkPriceMessage = "";
      });
  }

  async addToCart(item) {
    await this.loaderService.presentLoading("Updating Cart");
    this.retailCartService
      .addProductToCart(item, item.storeId, item.locationId)
      .subscribe(async (response) => {
        // console.log(response.cartDetails);
        if (response.cartDetails.length > 0) {
        }
        this.cartItems = response.cartDetails;
        this.discountConfig = response.discountConfig;
        this.updateCartParams();
        this.updateSalesSummary();
        await this.loaderService.loading.dismiss();


        //  response.cartDetails.forEach(element => {
        //    // tslint:disable-next-line: triple-equals
        //    if(element.id == item.id){
        //      item.itemInCart = 1;
        //      item.quantity = element.quantity;
        //    } else{
        //      item.itemInCart = 0;
        //    }
        //  });
      });
    //  console.log(item);
    if (this.isAsp) {
      this.checkPriceMessage = "Click on Check Final Price to proceed...";
    }
  }

  public async removeItemFromCart(item) {
    await this.loaderService.presentLoading("Updating Cart");
    await this.retailCartService
      .removeCartItemById(item)
      .subscribe(async (response) => {
        // console.log(response.cartDetails);
        if (response.cartDetails.length > 0) {
        }
        this.cartItems = response.cartDetails;
        this.discountConfig = response.discountConfig;
        this.updateCartParams();
        this.updateSalesSummary();
        await this.loaderService.loading.dismiss();

        // response.cartDetails.forEach(element => {
        //   // tslint:disable-next-line: triple-equals
        //   if(element.id == item.id){
        //     item.itemInCart = 1;
        //     item.quantity = element.quantity;
        //   } else{
        //     item.itemInCart = 0;
        //   }
        // });
      });
    if (this.isAsp) {
      this.checkPriceMessage = "Click on Check Final Price to proceed...";
    }
  }

  public async clearCart() {
    this.translate
      .get("CART.confirm_msg", { value: "world" })
      .subscribe((res: string) => {
        this.clearTitle = res;
      });
    this.translate
      .get("CART.confirm_text", { value: "world" })
      .subscribe((res: string) => {
        this.clearText = res;
      });
    this.translate
      .get("CART.no", { value: "world" })
      .subscribe((res: string) => {
        this.noBtn = res;
      });
    this.translate
      .get("CART.yes", { value: "world" })
      .subscribe((res: string) => {
        this.yesBtn = res;
      });
    const alert = await this.alertController.create({
      header: this.clearTitle,
      message: this.clearText,
      buttons: [
        {
          text: this.noBtn,
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {},
        },
        {
          text: this.yesBtn,
          handler: async () => {
            await this.loaderService.presentLoading("Updating Cart");
            await this.retailCartService.clearCart();
            // if failed handle error case
            await this.loaderService.loading.dismiss();
            this.renderCartData();

            // this.ngZone.run(() => this.router.navigate(['shopping/food/cart']));
          },
        },
      ],
    });

    await alert.present();
  }

  public async placeOrder() {
    const modal = await this.modalController.create({
      component: AutocheckoutFormComponent,
      backdropDismiss: false,
      componentProps: {
        storeId: this.storeId,
      },
    });
    modal.onDidDismiss().then(async (formResponse) => {
      if(formResponse.data!==undefined)
      await this.loaderService.presentLoading("updating...");
      
      this.retailCartService
        .checkoutCart(
          { ...formResponse.data.userInfo },
          this.cartItems,
          formResponse.data.formInfo
        )
        .toPromise()
        .then((response) => {
          if (response.orderDetails && response.orderDetails[0].orderId) {
            let orderId = response.orderDetails[0].orderId;
            this.loaderService.loading.dismiss();
            this.navControl.navigateRoot(
              ["shopping/retail/checkout/confirmed"],
              { queryParams: { orderId: response.orderDetails.orderId } }
            );
          } else {
            this.loaderService.loading.dismiss();
            // this.presentToast('Something went wrong, please try again!');
          }
        })
        .catch((e) => {
          // console.log(e);
          this.loaderService.loading.dismiss();
          // this.presentToast('Something went wrong, please try again!');
        });
    });

    return await modal.present();
  }
}
